<template>
  <div class="table-section" id="position">
    <div class="table-header">
      <h3 class="title">工单列表</h3>
      <el-button
        type="text"
        icon="el-icon-refresh"
        @click="refreshAll"
        :loading="refreshing"
      >
        刷新状态
      </el-button>
    </div>

    <el-table :data="tableData" class="table" v-loading="loading">
      <el-table-column type="index" width="60" label="序号"></el-table-column>
      <el-table-column label="素材ID" min-width="280">
        <template slot-scope="scope">
          <div class="material-ids">
            <el-tooltip
              :content="scope.row.materialIds.join(', ')"
              placement="top"
              :disabled="scope.row.materialIds.length <= 3"
            >
              <div>
                <span
                  v-for="(id, index) in scope.row.materialIds.slice(0, 3)"
                  :key="index"
                  class="id-tag"
                >
                  {{ id }}
                </span>
                <span v-if="scope.row.materialIds.length > 3" class="more-tag">
                  +{{ scope.row.materialIds.length - 3 }}
                </span>
              </div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="价格" width="100">
        <template slot-scope="scope">
          <span class="price">{{ scope.row.price || '-' }} 元</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="150">
        <template slot-scope="scope">
          <el-tag
            :type="getStatusType(scope.row.status)"
            size="small"
            effect="plain"
          >
            {{ scope.row.statusText }}
          </el-tag>
          <div v-if="scope.row.status === 'pending'" class="wait-time">
            <i class="el-icon-time"></i>
            <span>预计30分钟内</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" width="180">
        <template slot-scope="scope">
          <span class="time">{{ formatTime(scope.row.submitTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 'completed' || scope.row.status === 0 || scope.row.status === '0'">
            <!-- 未重新下载过 -->
            <div v-if="!scope.row.reDownloaded">
              <el-button
                type="danger"
                size="small"
                icon="el-icon-refresh"
                @click="download(scope.row, scope.$index)"
                :loading="scope.row.loading"
              >
                免费重下
              </el-button>
            </div>
            <!-- 已重新下载 -->
            <div v-else>
              <a
                v-if="scope.row.downurl"
                :href="scope.row.downurl"
                target="_blank"
                rel="nofollow"
              >
                <el-button type="primary" size="small" icon="el-icon-download">
                  下载
                </el-button>
              </a>
              <a
                v-if="scope.row.downurl2"
                :href="scope.row.downurl2"
                target="_blank"
                rel="nofollow"
                style="margin-left: 5px;"
              >
                <el-button type="success" size="small">
                  备用
                </el-button>
              </a>
            </div>
          </div>
          <div v-else-if="scope.row.status === 'failed' || scope.row.status === 2 || scope.row.status === '2'">
            <span class="fail-text">失败</span>
            <el-tooltip v-if="scope.row.remark" :content="scope.row.remark" placement="top">
              <i class="el-icon-warning-outline fail-icon"></i>
            </el-tooltip>
          </div>
          <div v-else>
            <el-button
              type="text"
              size="small"
              @click="refreshStatus(scope.row)"
              :loading="scope.row.refreshing"
            >
              <i class="el-icon-refresh"></i> 刷新
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="empty-tips" v-if="tableData.length === 0">
      <el-empty description="暂无工单记录">
        <template #description>
          <p>暂无工单记录</p>
          <p class="sub-text">提交素材ID后，工单将显示在此处</p>
        </template>
      </el-empty>
    </div>
  </div>
</template>

<script>
import { reDownload } from "../../../api/downLoad";

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      refreshing: false,
    };
  },
  computed: {
    tableData() {
      return this.data;
    },
  },
  methods: {
    getStatusType(status) {
      const typeMap = {
        pending: "warning",
        processing: "",
        completed: "success",
        failed: "danger",
        0: "success",
        1: "",
        2: "danger",
        5: "warning",
      };
      return typeMap[status] || "info";
    },
    refreshStatus(row) {
      this.$set(row, "refreshing", true);
      this.$emit("refreshStatus", row.id);
      setTimeout(() => {
        this.$set(row, "refreshing", false);
      }, 1000);
    },
    refreshAll() {
      this.refreshing = true;
      this.tableData.forEach((row) => {
        // 支持字符串和数字状态
        if (row.status === "pending" || row.status === "processing" ||
            row.status === 5 || row.status === 1 || row.status === "1" || row.status === "5") {
          this.$emit("refreshStatus", row.id);
        }
      });
      setTimeout(() => {
        this.refreshing = false;
      }, 1000);
    },
    download(item, index) {
      this.$set(this.data[index], "loading", true);
      let buydata = {
        imageID: item.materialIds && item.materialIds[0],
        webType: "shutterstock",
        format: item.format || -1,
      };
      reDownload(buydata)
        .then((result) => {
          this.$set(this.data[index], "loading", false);
          if (result.downloadUrl != null) {
            result.downloadUrl = result.downloadUrl.replace(
              "httpss:",
              "https:"
            );
          }

          if (result.downloadUrl2 != null) {
            result.downloadUrl2 = result.downloadUrl2.replace(
              "httpss:",
              "https:"
            );
          }
          this.$set(this.data[index], "downurl", result.downloadUrl);
          this.$set(this.data[index], "downurl2", result.downloadUrl2);
          this.$set(this.data[index], "reDownloaded", true);
        })
        .catch((error) => {
          this.$set(this.data[index], "loading", false);
          this.$message.error("重新下载失败，请稍后重试");
        });
    },
    formatTime(time) {
      if (!time) return "";
      // 如果时间戳是数字（毫秒）
      const date = typeof time === "number" ? new Date(time) : new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.table-section {
  margin-top: 30px;
  background: white;
  padding: 30px;
  border-radius: 4px;

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin: 0;
    }
  }

  .table {
    ::v-deep .el-table__header-wrapper {
      th {
        background-color: #f5f7fa;
        color: #333;
        font-weight: 600;
      }
    }

    .order-id {
      font-family: monospace;
      color: #666;
      font-size: 13px;
    }

    .material-ids {
      .id-tag {
        display: inline-block;
        padding: 2px 8px;
        margin: 2px;
        background: #f0f7ff;
        color: #0773fc;
        border-radius: 4px;
        font-size: 12px;
        font-family: monospace;
      }

      .more-tag {
        display: inline-block;
        padding: 2px 8px;
        margin: 2px;
        background: #e8e8e8;
        color: #666;
        border-radius: 4px;
        font-size: 12px;
      }
    }

    .wait-time {
      margin-top: 5px;
      font-size: 12px;
      color: #999;

      i {
        margin-right: 3px;
      }
    }

    .time {
      font-size: 13px;
      color: #666;

      &.pending {
        color: #999;
      }
    }

    .price {
      font-size: 14px;
      color: #f56c6c;
      font-weight: 500;
    }

    .fail-text {
      color: #f56c6c;
      font-size: 13px;
    }

    .fail-icon {
      color: #f56c6c;
      margin-left: 5px;
      cursor: help;
    }
  }

  .empty-tips {
    padding: 40px 0;

    .sub-text {
      color: #999;
      font-size: 13px;
      margin-top: 10px;
    }
  }
}
</style>
